export default "__VITE_ASSET__CqdX_z4v__"